import React from 'react'
import HeroBanner from '../components/Hero Banner/HeroBanner'
import Helmet from "react-helmet"

function ThankYou() {
    let heading = "Thank you for reaching out";
    let message = "Our team will be in touch with you shortly.";

   
    
  return (
    <>
    <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
        <HeroBanner
            Heading={heading}
            subHeading=""
            spanHeading=""
            Paragraph={message}
            btnText=""
            bgImg="/images/creatives/thank-hero-bg.jpg"
            darkBg={true}
            headingCenter={true}
            btn={false}
            socialLinks={false}
            serviceForm={false}
            isChevron={false}
        />
    </>
  )
}

export default ThankYou